import { useAtomValue } from "jotai";
import { projectAtom_SUSPENDS } from "@zapier/canvas-state";
import { Suspense } from "react";
import {
  Icon,
  SkeletonText,
  Text,
  TooltipWrapper,
} from "@zapier/design-system";
import styles from "./ProjectTitle.module.css";
import Link from "next/link";
import { ErrorBoundary } from "../ErrorBoundary";

type Props = { showLink?: boolean };

function ProjectTitleContent({ showLink }: Props) {
  const project = useAtomValue(projectAtom_SUSPENDS);

  if (!project) {
    return null;
  }

  return (
    <div className={styles.projectTitleWrapper}>
      <Text type="Body3">{project.title}</Text>
      {showLink && (
        <div className={styles.linkWrapper}>
          <TooltipWrapper content="Open project" position="west">
            {() => (
              <Link href={`/app/projects/${project.id}`} target="_blank">
                <Icon name="arrowOffsite" size={24} color="GrayWarm6" />
              </Link>
            )}
          </TooltipWrapper>
        </div>
      )}
    </div>
  );
}

function Loader() {
  return (
    <div>
      <SkeletonText lines={1} size="heading" />
    </div>
  );
}

export default function ProjectTitle({ showLink = true }: Props) {
  return (
    <ErrorBoundary renderNullOnError={true}>
      <Suspense fallback={<Loader />}>
        <ProjectTitleContent showLink={showLink} />
      </Suspense>
    </ErrorBoundary>
  );
}
